class AdpHeaderTopBarController {
  constructor() {
    this.name = 'adpHeaderTopBar';
  }
}

export default AdpHeaderTopBarController;



// WEBPACK FOOTER //
// ./src/app/components/adpHeaderTopBar/adpHeaderTopBar.controller.js